import React          from 'react'
import PropTypes      from 'prop-types'
import { withRouter } from 'react-router'

import { webLogin, terminalLogin } from 'alto-react-canteen/lib/routes'
import { terminalLoginSetting    } from 'alto-react-canteen/lib/settings'

class CanteenLogin extends React.Component
  @contextTypes: { auth: PropTypes.object, backend: PropTypes.object, settings: PropTypes.object }

  constructor: (props, context) ->
    super(props, context)

    setting = terminalLoginSetting(context.settings)

    if setting.enabled and not @props.forceWeb
      @context.auth.isRegisteredTerminal()
        .then ({ isRegistered }) => @redirect(isRegistered)

        null # otherwise runaway promise
    else
      @redirect(false)

  redirect: (isTerminal) ->
    location = if isTerminal then terminalLogin else webLogin

    @props.history.replace(pathname: location, \
                           search:   @props.history.location.search, \
                           state:    { terminal: isTerminal })

  render: ->
    null

export default withRouter(CanteenLogin)
